import * as METADATA_KEY from "../constants/metadata_keys";
import { injectBase } from "./inject_base";
var inject = injectBase(METADATA_KEY.INJECT_TAG);
export { inject };
//# sourceMappingURL=inject.js.map